import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGroupSimple } from '@fortawesome/pro-regular-svg-icons';

import SelectFilter from './select_filter';
import { getBrokers } from 'components/users/api';
import { mapId, mapName } from 'helpers/react_select_helpers';

const Broker = ({ data }) => (
  <>
    {data.imageUrl ? (
      <img className="avatar avatar-sm" src={data.imageUrl} />
    ) : (
      <FontAwesomeIcon className="fa-fw" icon={faUserGroupSimple} />
    )}
    {data.name}
  </>
);

const Option = ({ data, ...props }) => (
  <components.Option {...props}>
    <Broker data={data} />
  </components.Option>
);

const SingleValue = ({ data, ...props }) => (
  <components.SingleValue {...props} className="d-flex gap-2 align-items-center">
    <Broker data={data} />
  </components.SingleValue>
);

const BrokerFilter = ({ brokers, selectedBrokerId, onChange, ...props }) => {
  const [loadedBrokers, setLoadedBrokers] = useState();

  React.useEffect(() => {
    if (!brokers) {
      getBrokers().then(({ brokers }) => {
        setLoadedBrokers(brokers);
      });
    }
  }, []);

  brokers = brokers || loadedBrokers;
  if (!brokers) return null;

  return (
    <SelectFilter
      className="broker-filter-select"
      components={{ Option, SingleValue }}
      defaultValue={brokers[0]}
      getOptionLabel={mapName}
      getOptionValue={mapId}
      name="broker-filter"
      options={brokers}
      value={selectedBrokerId ? brokers.find(broker => broker.id === selectedBrokerId) : brokers[0]}
      onChange={onChange}
      {...props}
    />
  );
};

BrokerFilter.propTypes = {
  brokers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    imageUrl: PropTypes.string,
    name: PropTypes.string
  })),
  selectedBrokerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
};

const dataPropTypes = {
  data: PropTypes.object
};

Broker.propTypes = dataPropTypes;
Option.propTypes = dataPropTypes;
SingleValue.propTypes = dataPropTypes;

export default BrokerFilter;
